<div class="collection-props">
    <mat-checkbox (change)="toggleUseHotkeys()" [(ngModel)]="useHotkeys">
        &nbsp;{{ 'general.useHotkeys' | transloco }}
    </mat-checkbox>
    <mat-checkbox (change)="toggleOnIdle()" [(ngModel)]="onIdle">
        &nbsp;{{ 'general.onIdle' | transloco }}
    </mat-checkbox>

    @if (onIdle) {
        <div class="input-group">
            <mat-form-field appearance="outline" style="width: 160px;">
                <mat-label>{{ 'ai.durationSeconds' | transloco }}</mat-label>
                <input type="number" matInput [(ngModel)]="idleDuration" class="hide-spinners" (change)="changeIdleDuration()">
                <mat-icon matPrefix>schedule</mat-icon>
                <span matSuffix>sec</span>
            </mat-form-field>
        </div>
    }

    <mat-checkbox (change)="toggleMouseInterrupt()" [(ngModel)]="mouseInterrupt">
        &nbsp;{{ 'general.mouseInterrupt' | transloco }}
    </mat-checkbox>

    @if (mouseInterrupt) {
        <div class="input-group">
            <mat-form-field appearance="outline" style="width: 160px;">
                <mat-label>{{ 'general.mouseInterruptPage' | transloco }}</mat-label>
                <mat-select [(ngModel)]="mouseInterruptPage" (selectionChange)="changeMouseInterruptPage()">
                    @for (p of collectionPages; track $index) {
                        <mat-option [value]="p.page">{{ p.page }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>
    }
</div>
